import React from 'react';

import {getTestimonials} from '../../server/services/cms';

import ReviewsPage from '../js/pages/ReviewsPage';

export default function Page({testimonials}) {
  return <ReviewsPage testimonials={testimonials} />;
}

export async function getServerSideProps() {
  const testimonials = await getTestimonials();

  return {
    props: {
      testimonials: JSON.parse(JSON.stringify(testimonials)),
    },
  };
}
